<div class="sk-container" [ngClass]="{ 'sk-loading': !isLoaded && !isResponseError }">
    <loading-screen [displayed]="!isLoaded && !isResponseError" [templateType]="'GENERIC'"></loading-screen>
    @if (couponsList?.length) {
        <lazy-component
            id="tab-coupons"
            moduleUri="@lazy-modules-module/couponsModule/coupons.module#CouponsModule"
            data-crlat="accordionsList"
            entryComponent="CouponsCarouselComponent"
            [inputs]="{ couponsList: couponsList }">
        </lazy-component>
    }
    @if (isLoaded && couponsList?.length) {
        <coupons-list [couponsList]="couponsList" data-crlat="couponsListContainer" [isCoral]="isCoral" [isSportTab]="true"></coupons-list>
    }
    @if (isLoaded && isResponseError) {
        <request-error [reloadPage]="'COUPONS'" [loadFailed]="isResponseError"></request-error>
    }
    @if (isLoaded && !isResponseError && !couponsList.length) {
        <no-events [message]="'sb.noCouponsFound'"></no-events>
    }
</div>
